import { useMemo, useState } from 'react';

import { SettingOutlined } from '@ant-design/icons';
import { Empty, Input, Skeleton, Table } from 'antd';
import { T } from 'react-translator-component';

import * as S from './styled';
import { useVirtualGroupListPage } from './useVirtualGroupListPage';

import { COLORS } from '../../../../utils/theme/colors';
import { Pagination } from '../../../molecules/Pagination/Pagination';

const { Search } = Input;

const VirtualGroupListPage = () => {
  const { columns, loading, history, virtualGroup } = useVirtualGroupListPage();

  const [virtualGroupSearchValue, setVirtualGroupSearchValue] = useState('');

  const renderHeader = useMemo(
    () => (
      <S.Header>
        <S.Title>
          <SettingOutlined color={COLORS.black} />

          {T('Advanced Settings')}
        </S.Title>

        <S.NewButton
          size='large'
          type='primary'
          onClick={() => history.push('/virtual-groups/create')}
        >
          {T('Create Configuration')}
        </S.NewButton>
      </S.Header>
    ),
    [history],
  );

  return (
    <S.Div>
      {renderHeader}

      <Search
        className='search'
        placeholder={'Procure pelo ID ou descrição do carregador'}
        size='large'
        value={virtualGroupSearchValue}
        onSearch={() =>
          virtualGroup.request(
            1,
            virtualGroup?.pagination?.pageSize,
            virtualGroupSearchValue,
          )
        }
        onChange={(e) => setVirtualGroupSearchValue(e.target.value)}
        style={{ width: '50%', marginBottom: 16 }}
      />

      <Skeleton
        loading={loading}
        active
        paragraph={{
          rows: 5,
          width: '100%',
        }}
        title={false}
      >
        {virtualGroup?.data?.length ? (
          <S.TableWrapper>
            <Table
              dataSource={virtualGroup?.data}
              columns={columns}
              pagination={false}
              onRow={(row: any) => {
                return {
                  onClick: () => {
                    history.push(`/virtual-groups/view/${row.id}`);
                  },
                };
              }}
            />
            <Pagination
              currentPage={virtualGroup?.pagination?.page}
              pageSize={virtualGroup?.pagination?.pageSize}
              totalCount={virtualGroup?.pagination?.total}
              onPageChange={(page: number, pageSize: number | undefined) => {
                virtualGroup.request(page, pageSize, virtualGroupSearchValue);
              }}
            />
          </S.TableWrapper>
        ) : (
          <S.Blank>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description='Nenhuma configuração cadastrada'
              style={{ margin: 'auto', width: '100%' }}
            />
          </S.Blank>
        )}
      </Skeleton>
    </S.Div>
  );
};

export default VirtualGroupListPage;
